import React, { useState } from 'react';
import {Helmet} from "react-helmet-async";

import NewsletterSection from "../../components/NewsletterSection";




const products = [
    {
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="lucide lucide-database h-12 w-12 text-green-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                <path d="M3 5V19A9 3 0 0 0 21 19V5"></path>
                <path d="M3 12A9 3 0 0 0 21 12"></path>
            </svg>
        ),
        title: 'PostgreSQL',
        description: 'Leistungsstarke, skalierbare und vollständig verwaltete PostgreSQL-Datenbanken für Ihre anspruchsvollsten Anwendungen.',
        details: 'Verwaltete PostgreSQL-Datenbanken bieten hohe Leistung, einfache Integration und Sicherheit für Ihre Anwendungen. Sie sind für anspruchsvolle Anwendungen optimiert und skalierbar, um Ihre Geschäftsanforderungen zu erfüllen.',
        link: '#',
    },
    {
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="lucide lucide-lock h-12 w-12 text-green-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0110 0v4"></path>
            </svg>
        ),
        title: 'Keycloak',
        description: 'Open-Source-Identity- und Zugriffsmanagement für moderne Anwendungen und Services.',
        details: 'Keycloak bietet Single Sign-On (SSO), Identity Management und Zugriffskontrolle für Ihre Anwendungen. Einfach zu integrieren und anpassbar für Ihre spezifischen Anforderungen.',
        link: '#',
    },
    {
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="lucide lucide-box h-12 w-12 text-green-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 16V8a2 2 0 0 0-1-1.73L13 2.27a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4a2 2 0 0 0 1-1.73Z"></path>
                <path d="m3.3 7 8.7 5 8.7-5"></path>
                <path d="M12 22V12"></path>
            </svg>
        ),
        title: 'Weitere Open-Source-Produkte folgen...',
        description: 'Wir arbeiten daran, unser Angebot an Open-Source-Technologien zu erweitern.',
        details: 'Bald werden weitere leistungsstarke Open-Source-Lösungen und mehr verfügbar sein. Bleiben Sie dran!',
        link: '#',
    },
];

const ProductOverview = () => {
    const [selectedProduct, setSelectedProduct] = useState(null);

    const handleOpenModal = (product) => {
        setSelectedProduct(product);
    };

    const handleCloseModal = () => {
        setSelectedProduct(null);
    };

    return (
        <>
            {/* SEO-optimierter Head-Bereich mit Helmet */}
            <Helmet>
                <title>Unsere Produkte - Cloudtal</title>
                <meta
                    name="description"
                    content="Entdecken Sie unsere leistungsstarken und vollständig verwalteten Cloud-Dienste wie PostgreSQL. DSGVO-konform und sicher in Deutschland gehostet."
                />
                <meta
                    name="keywords"
                    content="Cloud-Dienste, PostgreSQL, Open Source, DSGVO, Hosting, Cloudtal"
                />
                <meta name="author" content="Cloudtal Team" />

                {/* Open Graph für Social Media */}
                <meta property="og:title" content="Unsere Produkte - Cloudtal" />
                <meta
                    property="og:description"
                    content="Erfahren Sie mehr über unsere leistungsstarken und verwalteten Cloud-Dienste, beginnend mit PostgreSQL."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.cloudtal.de/products" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://www.cloudtal.de/products" />
            </Helmet>
            <main className="flex-1">
                <section className="relative w-full min-h-screen bg-black text-white flex items-center justify-center overflow-hidden">
                    <div className="container px-4 md:px-6 text-center">
                        <h1 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl lg:text-6xl text-white">
                            Unsere Produkte
                        </h1>
                        <p className="mx-auto max-w-[700px] text-zinc-400 md:text-xl">
                            Entdecken Sie unsere leistungsstarken und vollständig verwalteten Cloud-Dienste, die speziell für Ihre geschäftlichen Anforderungen entwickelt wurden.
                        </p>
                    </div>
                </section>

                <section className="relative w-full py-48 md:py-64 lg:py-80 bg-zinc-900">
                    <div className="container px-4 md:px-6">
                        <div className="mx-auto grid max-w-5xl gap-6 py-12 lg:grid-cols-3">
                            {products.map((product, index) => (
                                <div
                                    key={index}
                                    className="flex flex-col bg-zinc-800 p-6 rounded-lg shadow-md hover:shadow-lg hover:-translate-y-1 transition duration-300"
                                >
                                    <div className="flex-grow flex flex-col items-center text-center">
                                        {product.icon}
                                        <h3 className="text-xl font-bold text-white mt-4">{product.title}</h3>
                                        <p className="text-zinc-400 mt-2">{product.description}</p>
                                    </div>
                                    <div className="mt-auto flex justify-center">
                                        <button
                                            className="text-green-500 hover:underline"
                                            onClick={() => handleOpenModal(product)}
                                        >
                                            Mehr erfahren
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {selectedProduct && (
                            <div className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-10">
                                <div className="bg-zinc-800 p-8 rounded-lg max-w-lg w-full relative">
                                    <button
                                        className="absolute top-4 right-4 text-zinc-400 hover:text-zinc-200"
                                        onClick={handleCloseModal}
                                    >
                                        &times;
                                    </button>
                                    <h2 className="text-3xl font-bold text-white mb-4">{selectedProduct.title}</h2>
                                    <p className="text-zinc-400 mb-6">{selectedProduct.details}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </section>

                <section className="relative w-full py-48 md:py-64 lg:py-80 bg-black">
                    <div className="container px-4 md:px-6">
                        <div className="flex flex-col items-center justify-center space-y-4 text-center">
                            <h2 className="text-3xl font-bold tracking-tighter sm:text-5xl text-white">PostgreSQL im Detail</h2>
                            <p className="max-w-[900px] text-zinc-500 md:text-xl dark:text-zinc-400">
                                Unsere verwalteten PostgreSQL-Datenbanken bieten Ihnen höchste Performance, Sicherheit und Zuverlässigkeit.
                                Profitieren Sie von automatischen Backups, Skalierbarkeit und umfassendem Support.
                            </p>
                        </div>
                        <div className="mx-auto grid max-w-5xl items-center gap-6 py-12 lg:grid-cols-2 lg:gap-12">
                            <div className="flex flex-col justify-center space-y-4">
                                <ul className="grid gap-6">
                                    <li>
                                        <div className="grid gap-1">
                                            <h3 className="text-xl font-bold text-white">Automatische Backups</h3>
                                            <p className="text-zinc-500 dark:text-zinc-400">
                                                Regelmäßige und sichere Backups, um Ihre Daten jederzeit wiederherstellen zu können.
                                            </p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="grid gap-1">
                                            <h3 className="text-xl font-bold text-white">Skalierbarkeit</h3>
                                            <p className="text-zinc-500 dark:text-zinc-400">
                                                Passen Sie Ihre Datenbankressourcen flexibel an Ihre wachsenden Anforderungen an.
                                            </p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="grid gap-1">
                                            <h3 className="text-xl font-bold text-white">Sicherheit</h3>
                                            <p className="text-zinc-500 dark:text-zinc-400">
                                                Höchste Sicherheitsstandards und DSGVO-Konformität für Ihre sensiblen Daten.
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div className="flex justify-end relative">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-database h-64 w-64 text-green-500">
                                    <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                                    <path d="M3 5V19A9 3 0 0 0 21 19V5"></path>
                                    <path d="M3 12A9 3 0 0 0 21 12"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </section>

                {/* NewsletterSection als Abschluss */}
                <NewsletterSection
                    title="Exklusives Beta-Tester-Programm"
                    description="Testen Sie als einer der wenigen unsere Beta-Version und erleben Sie die neuesten Funktionen vor allen anderen. Die Teilnehmerzahl ist streng limitiert – sichern Sie sich jetzt Ihren Platz!"
                    placeholder="Ihre E-Mail-Adresse"
                    buttonText="Jetzt registrieren"
                    privacyText="Wir respektieren Ihre Privatsphäre. Abmeldung jederzeit möglich."
                    additionalClassName="bg-black bg-bottom text-white"
                />
            </main>
        </>
    );
};

export default ProductOverview;
